import type { CashAccountKind } from '@core/generated/enums';

/** The glyph on an account's tile — Lucide, written out because Tailwind and the font scan source. */
export const kindIcon: Record<CashAccountKind, string> = {
  Till: 'icon icon-banknote',
  PettyCash: 'icon icon-wallet',
  Bank: 'icon icon-landmark',
};
